module.exports = __webpack_public_path__ + "media/Images/principal-simply-retirement-logo-stacked-7b4f0abf8c2bb0d07f35ad8c127f1ddd.svg";